import React from 'react';
import {Button} from '@mui/material';
import {Upload16} from '@carbon/icons-react';
import {tid} from '../../../testUtils';

type FileInputButtonProps = {
  label: string;
  onChange: (files: FileList) => void;
  disabled?: boolean;
  accept?: string;
};

const FileInputButton: React.FC<FileInputButtonProps> = ({label, onChange, disabled = false, accept}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.currentTarget.files) {
      onChange(event.currentTarget.files);
    }
  };

  return (
    <label>
      <Button
        disabled={disabled}
        style={{marginLeft: -6}}
        variant="text"
        color="primary"
        startIcon={<Upload16 />}
        component="span"
        {...tid('btn', 'select-import-file')}
      >
        {label}
      </Button>
      <input
        type="file"
        disabled={disabled}
        onChange={handleChange}
        style={{display: 'none'}}
        accept={accept}
        {...tid('input-file')}
      />
    </label>
  );
};

export default FileInputButton;
